import { useEffect } from "react";
import { CheckIcon, PlusIcon } from "@heroicons/react/24/outline";
import useTranslation from "@babackapp/translations/use-translation";
import { ShopMembersControllerGetShopMembersResponse } from "@babackapp/private-api-client/types";
import SimpleMenu from "@babackapp/ui/components/simple-menu";
import LogoIcon from "@/components-legacy/logoIcon";

type UserPickerProps = {
  readOnly?: boolean;
  usersPicked: string[];
  onUpdateUser: (userId: string) => void;
};

export default function UserPicker({
  readOnly = false,
  usersPicked,
  onUpdateUser,
}: UserPickerProps) {
  const t = useTranslation();
  let users: ShopMembersControllerGetShopMembersResponse | undefined = [];
  useEffect(() => {
    users = users || [];
  }, [users]);

  const menu = users.map(({ user }) => ({
    onClick: () => onUpdateUser(user?.id || ""),
    renderTitle: () => (
      <div className="flex flex-1">
        <LogoIcon
          imageId={user?.logoId || ""}
          type="user"
          className="h-4 w-4 mr-1"
        />
        <div className="flex-1">
          {user?.firstName
            ? `${user.firstName} ${user.lastName || ""}`
            : user?.email}
        </div>
        <CheckIcon
          className={`h-4 w-4 ml-2 text-green-400 ${
            usersPicked.includes(user?.id || "") ? "visible" : "invisible"
          }`}
        />
      </div>
    ),
  }));

  return (
    <>
      {readOnly ? (
        <div className="space-y-2">
          {users.length > 0 &&
            users.map(({ user }, index) => (
              <li key={index} className="flex">
                <LogoIcon
                  imageId={user?.logoId || ""}
                  type="user"
                  className="h-4 w-4"
                />
                <div className="ml-3 flex flex-1 content-center flex-col">
                  <span className="text-sm font-medium text-gray-900 text-left">
                    {user?.firstName
                      ? `${user.firstName} ${user.lastName}`
                      : user?.email}
                  </span>
                </div>
              </li>
            ))}
        </div>
      ) : (
        <div>
          <SimpleMenu
            className="h-full"
            type={"neutral"}
            button={
              users.length === 0 ? (
                <div className="text-sm flex font-normal text-gray-400 hover:text-gray-600 cursor-pointer items-center">
                  <PlusIcon className="h-4 w-4 mr-2" />
                  {t("returnDetail.rightBar.assigneUser")}
                </div>
              ) : (
                <div className="space-y-2 w-fit p-2 border-y rounded-md border-x border-transparent hover:border-gray-200 relative cursor-pointer hover:bg-white">
                  {users.map(({ user }, index) => (
                    <li key={index} className="flex">
                      <LogoIcon
                        imageId={user?.logoId || ""}
                        type="user"
                        className="h-4 w-4"
                      />
                      <div className="ml-3 flex flex-1 content-center flex-col">
                        <span className="text-sm font-base text-gray-900 text-left">
                          {user?.firstName
                            ? `${user.firstName} ${user.lastName}`
                            : user?.email}
                        </span>
                      </div>
                    </li>
                  ))}
                </div>
              )
            }
            menu={menu}
          />
        </div>
      )}
    </>
  );
}
